import { random } from 'lodash'
import qs from 'qs'

const heartBgs = ['yellowbg', 'purplebg', 'pinkbg']

export const addUpHeaters = (_this) => {
  const id =  Date.now()
  const upHeaters = _this.$store.state.upHeaters.slice()
  upHeaters.push({
    className: heartBgs[random(0, 2)],
    id,
    left: `${random(0, 40) - 10}px`
  })
  _this.$store.dispatch('updateUpHeaters', upHeaters)
}

export const getParentUrl = () => {
  let url = '';
  if (parent !== window) {
      try {
         url = parent.location.href;
      }catch (e) {
         url = document.referrer;
      }
   }
   return url;
}

export const postMessage = (data: any) => {
   const parentUrl = getParentUrl()
   if (parentUrl) {
    top.postMessage(data, parentUrl)
   }
}

// fix redirectUrl
export const redirectUrlPrefix = (redirectUrl) => {
   const url = redirectUrl.split('?')
   const queryJson = qs.parse(url[1])
   const { openUrl = '' } = queryJson
   console.log('openUrl', `${url[0]}?openUrl=${encodeURIComponent(openUrl.toString())}${url[2] ? `?${url[2]}` : ''}`)
   return `${url[0]}?openUrl=${encodeURIComponent(openUrl.toString())}${url[2] ? `?${url[2]}` : ''}`
}

// 兼容嵌套iframe 跳转
export const redirectTo = (url) => {
   if (self !== top) {
      window.parent.location.replace(url)
   } else {
      window.location.replace(url)
   }
}




